import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { usePermissionsContext } from "../contexts/PermissionsContext";

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export function AdminRoute({ children }) {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/app/log" replace />;
  }

  return children;
}

export function RBACRoute({ menuKey, children }) {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const { canAccessMenu, loading: permsLoading } = usePermissionsContext();
  const location = useLocation();

  if (authLoading || permsLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!canAccessMenu(menuKey)) {
    return <Navigate to="/app/log" replace />;
  }

  return children;
}

export function PublicRoute({ children }) {
  const { isAuthenticated, isAdmin, isTeamLeader, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  if (isAuthenticated) {
    // Redirect admins and team leaders to dashboard, others to daily log
    if (isAdmin || isTeamLeader) {
      return <Navigate to="/app/dashboard" replace />;
    }
    const from = location.state?.from?.pathname || "/app/log";
    return <Navigate to={from} replace />;
  }

  return children;
}
